export default "__VITE_PUBLIC_ASSET__9726cfe5__"